import type { ComponentProps, FC } from 'react';

import TooltipHelper from '@/components/TooltipHelper.tsx';

import styles from './MapBooth.module.scss';

type MapBoothProps = {
  boothIndex: number;
  boothName: string;
  onBoothSelect: (booth: number) => void;
  // boothId of highlighted booth
  highlightedBoothIndex: number;
} & ComponentProps<'rect'>;

const MapBooth: FC<MapBoothProps> = ({
  boothIndex,
  boothName,
  onBoothSelect,
  highlightedBoothIndex,
  ...svgProps
}) => {
  return (
    <TooltipHelper
      id={`booth-${boothIndex}-tooltip`}
      title={boothName}
      child={
        <g
          className={styles['booth']}
          tabIndex={0}
          role="radio"
          aria-checked={highlightedBoothIndex === boothIndex}
          onClick={() => onBoothSelect(boothIndex)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === 'Space') {
              onBoothSelect(boothIndex);
            }
          }}
        >
          <rect {...svgProps} />
        </g>
      }
    />
  );
};

export default MapBooth;
